// The PageHero component allows an arbitrary number of content sections
// to show up in the right hand content area. This component is used to
// indicate those sections.
import React from 'react'
import classnames from "classnames"

// The adopt prop indicates whether to adopt the children as a content section,
// in which case there must only be one, as opposed to the standard behavior of
// wrapping the children.
const component = ({children, adopt}) => {
  if(adopt) {
    const child = React.Children.only(children);
    const newClassName =
      classnames(child.props.className, "page-hero__content-section");

    return React.cloneElement(child, {className: newClassName });
  }

  return (
    <div className="page-hero__content-section">
      {children}
    </div>
  );
};

component.displayName = "PageHeroContentSection";
export default component;


// WEBPACK FOOTER //
// ./client/components/PageHeroContentSection/index.js